import Footer from '../../../navigation/footerContainer';
import UserContainer from './userContainer';


export default function ManageUsersPage (){
    return(
        <>
            <UserContainer />
            <Footer />
        </>
    )
}